/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { AddBankLoanRequest } from "../model"
// @ts-ignore
import type { AddBonusRequest } from "../model"
// @ts-ignore
import type { AddGuaranteeRequest } from "../model"
// @ts-ignore
import type { AddLoanRequest } from "../model"
// @ts-ignore
import type { ApiBankLoan } from "../model"
// @ts-ignore
import type { ApiBonusOperation } from "../model"
// @ts-ignore
import type { ApiFinancialPlanResourcesImport } from "../model"
// @ts-ignore
import type { ApiGuaranteeOperation } from "../model"
// @ts-ignore
import type { ApiInvestmentOperation } from "../model"
// @ts-ignore
import type { ApiOperations } from "../model"
// @ts-ignore
import type { ApiOperationsImport } from "../model"
// @ts-ignore
import type { BreakingTransitionResponse } from "../model"
// @ts-ignore
import type { ChangeLifecycleRequest } from "../model"
// @ts-ignore
import type { CheckTermsOfUseRequest } from "../model"
// @ts-ignore
import type { Note } from "../model"
// @ts-ignore
import type { NoubaLightProject } from "../model"
// @ts-ignore
import type { ProductsByAssociation } from "../model"
// @ts-ignore
import type { Project } from "../model"
// @ts-ignore
import type { UpdateBankLoanRequest } from "../model"
// @ts-ignore
import type { UpdateBonusRequest } from "../model"
// @ts-ignore
import type { UpdateGuaranteeRequest } from "../model"
// @ts-ignore
import type { UpdateLoanRequest } from "../model"
// @ts-ignore
import type { UpdateProjectRequest } from "../model"
/**
 * ProjectResourceV2Api - axios parameter creator
 */
export const ProjectResourceV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Add bank loan
     * @param {number} projectId
     * @param {AddBankLoanRequest} addBankLoanRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBankLoan: async (
      projectId: number,
      addBankLoanRequest: AddBankLoanRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("addBankLoan", "projectId", projectId)
      // verify required parameter 'addBankLoanRequest' is not null or undefined
      assertParamExists("addBankLoan", "addBankLoanRequest", addBankLoanRequest)
      const localVarPath = `/v2.0/projects/{projectId}/operations/bank-loan`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addBankLoanRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Add bonus
     * @param {number} projectId
     * @param {AddBonusRequest} addBonusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBonus: async (
      projectId: number,
      addBonusRequest: AddBonusRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("addBonus", "projectId", projectId)
      // verify required parameter 'addBonusRequest' is not null or undefined
      assertParamExists("addBonus", "addBonusRequest", addBonusRequest)
      const localVarPath = `/v2.0/projects/{projectId}/operations/bonus`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addBonusRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Add guarantee
     * @param {number} projectId
     * @param {AddGuaranteeRequest} addGuaranteeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addGuarantee: async (
      projectId: number,
      addGuaranteeRequest: AddGuaranteeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("addGuarantee", "projectId", projectId)
      // verify required parameter 'addGuaranteeRequest' is not null or undefined
      assertParamExists("addGuarantee", "addGuaranteeRequest", addGuaranteeRequest)
      const localVarPath = `/v2.0/projects/{projectId}/operations/guarantee`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addGuaranteeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Add investment
     * @param {number} projectId
     * @param {AddLoanRequest} addLoanRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLoan: async (
      projectId: number,
      addLoanRequest: AddLoanRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("addLoan", "projectId", projectId)
      // verify required parameter 'addLoanRequest' is not null or undefined
      assertParamExists("addLoan", "addLoanRequest", addLoanRequest)
      const localVarPath = `/v2.0/projects/{projectId}/operations/loan`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addLoanRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Change lifecycle
     * @param {number} projectId
     * @param {ChangeLifecycleRequest} changeLifecycleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeLifecycle: async (
      projectId: number,
      changeLifecycleRequest: ChangeLifecycleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("changeLifecycle", "projectId", projectId)
      // verify required parameter 'changeLifecycleRequest' is not null or undefined
      assertParamExists("changeLifecycle", "changeLifecycleRequest", changeLifecycleRequest)
      const localVarPath = `/v2.0/projects/{projectId}/lifecycle`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        changeLifecycleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get note\'s terms of service
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkAllTermsOfUse: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("checkAllTermsOfUse", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}/conditions-utilisation`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get note\'s terms of service
     * @param {number} projectId
     * @param {CheckTermsOfUseRequest} [checkTermsOfUseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkTermsOfUse: async (
      projectId: number,
      checkTermsOfUseRequest?: CheckTermsOfUseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("checkTermsOfUse", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}/conditions-utilisation`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkTermsOfUseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Create a note on project
     * @param {number} projectId
     * @param {CreateNoteOnProjectNewLifeCycleEnum} [newLifeCycle]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createNoteOnProject: async (
      projectId: number,
      newLifeCycle?: CreateNoteOnProjectNewLifeCycleEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("createNoteOnProject", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (newLifeCycle !== undefined) {
        localVarQueryParameter["newLifeCycle"] = newLifeCycle
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete bank loan
     * @param {number} projectId
     * @param {string} bankLoanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBankLoan: async (
      projectId: number,
      bankLoanId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("deleteBankLoan", "projectId", projectId)
      // verify required parameter 'bankLoanId' is not null or undefined
      assertParamExists("deleteBankLoan", "bankLoanId", bankLoanId)
      const localVarPath = `/v2.0/projects/{projectId}/operations/bank-loans/{bankLoanId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{bankLoanId}", encodeURIComponent(String(bankLoanId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete bonus
     * @param {number} projectId
     * @param {string} bonusId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBonus: async (
      projectId: number,
      bonusId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("deleteBonus", "projectId", projectId)
      // verify required parameter 'bonusId' is not null or undefined
      assertParamExists("deleteBonus", "bonusId", bonusId)
      const localVarPath = `/v2.0/projects/{projectId}/operations/bonus/{bonusId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{bonusId}", encodeURIComponent(String(bonusId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete guarantee
     * @param {number} projectId
     * @param {string} guaranteeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGuarantee: async (
      projectId: number,
      guaranteeId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("deleteGuarantee", "projectId", projectId)
      // verify required parameter 'guaranteeId' is not null or undefined
      assertParamExists("deleteGuarantee", "guaranteeId", guaranteeId)
      const localVarPath = `/v2.0/projects/{projectId}/operations/guarantees/{guaranteeId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{guaranteeId}", encodeURIComponent(String(guaranteeId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete investment
     * @param {number} projectId
     * @param {string} investmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvestment: async (
      projectId: number,
      investmentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("deleteInvestment", "projectId", projectId)
      // verify required parameter 'investmentId' is not null or undefined
      assertParamExists("deleteInvestment", "investmentId", investmentId)
      const localVarPath = `/v2.0/projects/{projectId}/operations/investments/{investmentId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{investmentId}", encodeURIComponent(String(investmentId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Look for projects
     * @param {string} [searchString] What to look for
     * @param {Set<FindProjectsSearchFieldsEnum>} [searchFields] Fields to filter on. null is equivalent to libelle+structureNom+porteursNomUsage
     * @param {boolean} [filterOnLoggedAdvisor] Add additional filter on current advisor
     * @param {string} [filterOnCommitteeDate] Add additional filter given committee date
     * @param {Set<string>} [filterOnProjectPhase] Project phases to filter on (default is no filter)
     * @param {Set<string>} [filterOnProjectActivityArea] Project activity areas to filter on (default is no filter)
     * @param {Set<string>} [filterOnFiliere] Filière to filter on (default is no filter)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findProjects: async (
      searchString?: string,
      searchFields?: Set<FindProjectsSearchFieldsEnum>,
      filterOnLoggedAdvisor?: boolean,
      filterOnCommitteeDate?: string,
      filterOnProjectPhase?: Set<string>,
      filterOnProjectActivityArea?: Set<string>,
      filterOnFiliere?: Set<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v2.0/projects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (searchString !== undefined) {
        localVarQueryParameter["searchString"] = searchString
      }

      if (searchFields) {
        localVarQueryParameter["searchFields"] = Array.from(searchFields)
      }

      if (filterOnLoggedAdvisor !== undefined) {
        localVarQueryParameter["filterOnLoggedAdvisor"] = filterOnLoggedAdvisor
      }

      if (filterOnCommitteeDate !== undefined) {
        localVarQueryParameter["filterOnCommitteeDate"] =
          (filterOnCommitteeDate as any) instanceof Date
            ? (filterOnCommitteeDate as any).toISOString().substring(0, 10)
            : filterOnCommitteeDate
      }

      if (filterOnProjectPhase) {
        localVarQueryParameter["filterOnProjectPhase"] = Array.from(filterOnProjectPhase)
      }

      if (filterOnProjectActivityArea) {
        localVarQueryParameter["filterOnProjectActivityArea"] = Array.from(
          filterOnProjectActivityArea
        )
      }

      if (filterOnFiliere) {
        localVarQueryParameter["filterOnFiliere"] = Array.from(filterOnFiliere)
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Check if lifecycle transition is authorized for project
     * @param {number} projectId
     * @param {GetBreakingLifecycleTransition1NewLifeCycleEnum} newLifeCycle
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getBreakingLifecycleTransition1: async (
      projectId: number,
      newLifeCycle: GetBreakingLifecycleTransition1NewLifeCycleEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getBreakingLifecycleTransition1", "projectId", projectId)
      // verify required parameter 'newLifeCycle' is not null or undefined
      assertParamExists("getBreakingLifecycleTransition1", "newLifeCycle", newLifeCycle)
      const localVarPath = `/v2.0/projects/{projectId}/check-lifecycle-transition`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (newLifeCycle !== undefined) {
        localVarQueryParameter["newLifeCycle"] = newLifeCycle
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get operations by projectId
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOperations: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getOperations", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}/operations`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get products by projectId and associationId
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductsByAssociation: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getProductsByAssociation", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}/products-by-association`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get project by its nouba id and association id
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProject: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getProject", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get recently viewed projects by advisor id
     * @param {string} [advisorId] advisor id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecentlyViewedProjectsByAdvisorId: async (
      advisorId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v2.0/projects/recently-viewed`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (advisorId !== undefined) {
        localVarQueryParameter["advisorId"] = advisorId
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Used by nouba to import financial plan resources
     * @summary Get financial plan resources import by projectId
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    importFinancialPlanResources1: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("importFinancialPlanResources1", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}/financial-plan-resources/import`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Used by nouba to import operations
     * @summary Get operation import by projectId
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    importOperations1: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("importOperations1", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}/operations/import`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get note url for project
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    retrieveNoteUrlOnProject: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("retrieveNoteUrlOnProject", "projectId", projectId)
      const localVarPath = `/v2.0/projects/{projectId}/note-url`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update bank loan
     * @param {number} projectId
     * @param {string} bankLoanId
     * @param {UpdateBankLoanRequest} updateBankLoanRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBankLoan: async (
      projectId: number,
      bankLoanId: string,
      updateBankLoanRequest: UpdateBankLoanRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateBankLoan", "projectId", projectId)
      // verify required parameter 'bankLoanId' is not null or undefined
      assertParamExists("updateBankLoan", "bankLoanId", bankLoanId)
      // verify required parameter 'updateBankLoanRequest' is not null or undefined
      assertParamExists("updateBankLoan", "updateBankLoanRequest", updateBankLoanRequest)
      const localVarPath = `/v2.0/projects/{projectId}/operations/bank-loans/{bankLoanId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{bankLoanId}", encodeURIComponent(String(bankLoanId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBankLoanRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update bonus
     * @param {number} projectId
     * @param {string} bonusId
     * @param {UpdateBonusRequest} updateBonusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBonus: async (
      projectId: number,
      bonusId: string,
      updateBonusRequest: UpdateBonusRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateBonus", "projectId", projectId)
      // verify required parameter 'bonusId' is not null or undefined
      assertParamExists("updateBonus", "bonusId", bonusId)
      // verify required parameter 'updateBonusRequest' is not null or undefined
      assertParamExists("updateBonus", "updateBonusRequest", updateBonusRequest)
      const localVarPath = `/v2.0/projects/{projectId}/operations/bonuses/{bonusId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{bonusId}", encodeURIComponent(String(bonusId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBonusRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update guarantee
     * @param {number} projectId
     * @param {string} guaranteeId
     * @param {UpdateGuaranteeRequest} updateGuaranteeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateGuarantee: async (
      projectId: number,
      guaranteeId: string,
      updateGuaranteeRequest: UpdateGuaranteeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateGuarantee", "projectId", projectId)
      // verify required parameter 'guaranteeId' is not null or undefined
      assertParamExists("updateGuarantee", "guaranteeId", guaranteeId)
      // verify required parameter 'updateGuaranteeRequest' is not null or undefined
      assertParamExists("updateGuarantee", "updateGuaranteeRequest", updateGuaranteeRequest)
      const localVarPath = `/v2.0/projects/{projectId}/operations/guarantees/{guaranteeId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{guaranteeId}", encodeURIComponent(String(guaranteeId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateGuaranteeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update investment
     * @param {number} projectId
     * @param {string} loanId
     * @param {UpdateLoanRequest} updateLoanRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLoan: async (
      projectId: number,
      loanId: string,
      updateLoanRequest: UpdateLoanRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateLoan", "projectId", projectId)
      // verify required parameter 'loanId' is not null or undefined
      assertParamExists("updateLoan", "loanId", loanId)
      // verify required parameter 'updateLoanRequest' is not null or undefined
      assertParamExists("updateLoan", "updateLoanRequest", updateLoanRequest)
      const localVarPath = `/v2.0/projects/{projectId}/operations/loan/{loanId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{loanId}", encodeURIComponent(String(loanId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateLoanRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update nouba project
     * @param {number} projectId
     * @param {UpdateProjectRequest} updateProjectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProject: async (
      projectId: number,
      updateProjectRequest: UpdateProjectRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateProject", "projectId", projectId)
      // verify required parameter 'updateProjectRequest' is not null or undefined
      assertParamExists("updateProject", "updateProjectRequest", updateProjectRequest)
      const localVarPath = `/v2.0/projects/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateProjectRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ProjectResourceV2Api - functional programming interface
 */
export const ProjectResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Add bank loan
     * @param {number} projectId
     * @param {AddBankLoanRequest} addBankLoanRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addBankLoan(
      projectId: number,
      addBankLoanRequest: AddBankLoanRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addBankLoan(
        projectId,
        addBankLoanRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.addBankLoan"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Add bonus
     * @param {number} projectId
     * @param {AddBonusRequest} addBonusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addBonus(
      projectId: number,
      addBonusRequest: AddBonusRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addBonus(
        projectId,
        addBonusRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.addBonus"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Add guarantee
     * @param {number} projectId
     * @param {AddGuaranteeRequest} addGuaranteeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addGuarantee(
      projectId: number,
      addGuaranteeRequest: AddGuaranteeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addGuarantee(
        projectId,
        addGuaranteeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.addGuarantee"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Add investment
     * @param {number} projectId
     * @param {AddLoanRequest} addLoanRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addLoan(
      projectId: number,
      addLoanRequest: AddLoanRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addLoan(
        projectId,
        addLoanRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.addLoan"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Change lifecycle
     * @param {number} projectId
     * @param {ChangeLifecycleRequest} changeLifecycleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changeLifecycle(
      projectId: number,
      changeLifecycleRequest: ChangeLifecycleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.changeLifecycle(
        projectId,
        changeLifecycleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.changeLifecycle"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get note\'s terms of service
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkAllTermsOfUse(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string> }>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkAllTermsOfUse(
        projectId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.checkAllTermsOfUse"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get note\'s terms of service
     * @param {number} projectId
     * @param {CheckTermsOfUseRequest} [checkTermsOfUseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkTermsOfUse(
      projectId: number,
      checkTermsOfUseRequest?: CheckTermsOfUseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkTermsOfUse(
        projectId,
        checkTermsOfUseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.checkTermsOfUse"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a note on project
     * @param {number} projectId
     * @param {CreateNoteOnProjectNewLifeCycleEnum} [newLifeCycle]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async createNoteOnProject(
      projectId: number,
      newLifeCycle?: CreateNoteOnProjectNewLifeCycleEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createNoteOnProject(
        projectId,
        newLifeCycle,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.createNoteOnProject"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete bank loan
     * @param {number} projectId
     * @param {string} bankLoanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteBankLoan(
      projectId: number,
      bankLoanId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBankLoan(
        projectId,
        bankLoanId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.deleteBankLoan"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete bonus
     * @param {number} projectId
     * @param {string} bonusId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteBonus(
      projectId: number,
      bonusId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBonus(
        projectId,
        bonusId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.deleteBonus"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete guarantee
     * @param {number} projectId
     * @param {string} guaranteeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteGuarantee(
      projectId: number,
      guaranteeId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGuarantee(
        projectId,
        guaranteeId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.deleteGuarantee"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete investment
     * @param {number} projectId
     * @param {string} investmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteInvestment(
      projectId: number,
      investmentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvestment(
        projectId,
        investmentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.deleteInvestment"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Look for projects
     * @param {string} [searchString] What to look for
     * @param {Set<FindProjectsSearchFieldsEnum>} [searchFields] Fields to filter on. null is equivalent to libelle+structureNom+porteursNomUsage
     * @param {boolean} [filterOnLoggedAdvisor] Add additional filter on current advisor
     * @param {string} [filterOnCommitteeDate] Add additional filter given committee date
     * @param {Set<string>} [filterOnProjectPhase] Project phases to filter on (default is no filter)
     * @param {Set<string>} [filterOnProjectActivityArea] Project activity areas to filter on (default is no filter)
     * @param {Set<string>} [filterOnFiliere] Filière to filter on (default is no filter)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findProjects(
      searchString?: string,
      searchFields?: Set<FindProjectsSearchFieldsEnum>,
      filterOnLoggedAdvisor?: boolean,
      filterOnCommitteeDate?: string,
      filterOnProjectPhase?: Set<string>,
      filterOnProjectActivityArea?: Set<string>,
      filterOnFiliere?: Set<string>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NoubaLightProject>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findProjects(
        searchString,
        searchFields,
        filterOnLoggedAdvisor,
        filterOnCommitteeDate,
        filterOnProjectPhase,
        filterOnProjectActivityArea,
        filterOnFiliere,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.findProjects"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Check if lifecycle transition is authorized for project
     * @param {number} projectId
     * @param {GetBreakingLifecycleTransition1NewLifeCycleEnum} newLifeCycle
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async getBreakingLifecycleTransition1(
      projectId: number,
      newLifeCycle: GetBreakingLifecycleTransition1NewLifeCycleEnum,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreakingTransitionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBreakingLifecycleTransition1(
        projectId,
        newLifeCycle,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.getBreakingLifecycleTransition1"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get operations by projectId
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOperations(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOperations>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOperations(projectId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.getOperations"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get products by projectId and associationId
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProductsByAssociation(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductsByAssociation>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsByAssociation(
        projectId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.getProductsByAssociation"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get project by its nouba id and association id
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProject(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(projectId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.getProject"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get recently viewed projects by advisor id
     * @param {string} [advisorId] advisor id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRecentlyViewedProjectsByAdvisorId(
      advisorId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NoubaLightProject>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getRecentlyViewedProjectsByAdvisorId(advisorId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.getRecentlyViewedProjectsByAdvisorId"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Used by nouba to import financial plan resources
     * @summary Get financial plan resources import by projectId
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async importFinancialPlanResources1(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFinancialPlanResourcesImport>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.importFinancialPlanResources1(
        projectId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.importFinancialPlanResources1"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Used by nouba to import operations
     * @summary Get operation import by projectId
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async importOperations1(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOperationsImport>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.importOperations1(
        projectId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.importOperations1"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get note url for project
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async retrieveNoteUrlOnProject(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveNoteUrlOnProject(
        projectId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.retrieveNoteUrlOnProject"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update bank loan
     * @param {number} projectId
     * @param {string} bankLoanId
     * @param {UpdateBankLoanRequest} updateBankLoanRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBankLoan(
      projectId: number,
      bankLoanId: string,
      updateBankLoanRequest: UpdateBankLoanRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiBankLoan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateBankLoan(
        projectId,
        bankLoanId,
        updateBankLoanRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.updateBankLoan"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update bonus
     * @param {number} projectId
     * @param {string} bonusId
     * @param {UpdateBonusRequest} updateBonusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBonus(
      projectId: number,
      bonusId: string,
      updateBonusRequest: UpdateBonusRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiBonusOperation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateBonus(
        projectId,
        bonusId,
        updateBonusRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.updateBonus"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update guarantee
     * @param {number} projectId
     * @param {string} guaranteeId
     * @param {UpdateGuaranteeRequest} updateGuaranteeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateGuarantee(
      projectId: number,
      guaranteeId: string,
      updateGuaranteeRequest: UpdateGuaranteeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiGuaranteeOperation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateGuarantee(
        projectId,
        guaranteeId,
        updateGuaranteeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.updateGuarantee"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update investment
     * @param {number} projectId
     * @param {string} loanId
     * @param {UpdateLoanRequest} updateLoanRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLoan(
      projectId: number,
      loanId: string,
      updateLoanRequest: UpdateLoanRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiInvestmentOperation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateLoan(
        projectId,
        loanId,
        updateLoanRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.updateLoan"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update nouba project
     * @param {number} projectId
     * @param {UpdateProjectRequest} updateProjectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProject(
      projectId: number,
      updateProjectRequest: UpdateProjectRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(
        projectId,
        updateProjectRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectResourceV2Api.updateProject"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ProjectResourceV2Api - factory interface
 */
export const ProjectResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Add bank loan
     * @param {ProjectResourceV2ApiAddBankLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBankLoan(
      requestParameters: ProjectResourceV2ApiAddBankLoanRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .addBankLoan(requestParameters.projectId, requestParameters.addBankLoanRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Add bonus
     * @param {ProjectResourceV2ApiAddBonusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBonus(
      requestParameters: ProjectResourceV2ApiAddBonusRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .addBonus(requestParameters.projectId, requestParameters.addBonusRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Add guarantee
     * @param {ProjectResourceV2ApiAddGuaranteeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addGuarantee(
      requestParameters: ProjectResourceV2ApiAddGuaranteeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .addGuarantee(requestParameters.projectId, requestParameters.addGuaranteeRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Add investment
     * @param {ProjectResourceV2ApiAddLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLoan(
      requestParameters: ProjectResourceV2ApiAddLoanRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .addLoan(requestParameters.projectId, requestParameters.addLoanRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Change lifecycle
     * @param {ProjectResourceV2ApiChangeLifecycleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeLifecycle(
      requestParameters: ProjectResourceV2ApiChangeLifecycleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .changeLifecycle(
          requestParameters.projectId,
          requestParameters.changeLifecycleRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get note\'s terms of service
     * @param {ProjectResourceV2ApiCheckAllTermsOfUseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkAllTermsOfUse(
      requestParameters: ProjectResourceV2ApiCheckAllTermsOfUseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<{ [key: string]: Array<string> }> {
      return localVarFp
        .checkAllTermsOfUse(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get note\'s terms of service
     * @param {ProjectResourceV2ApiCheckTermsOfUseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkTermsOfUse(
      requestParameters: ProjectResourceV2ApiCheckTermsOfUseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .checkTermsOfUse(
          requestParameters.projectId,
          requestParameters.checkTermsOfUseRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Create a note on project
     * @param {ProjectResourceV2ApiCreateNoteOnProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createNoteOnProject(
      requestParameters: ProjectResourceV2ApiCreateNoteOnProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .createNoteOnProject(requestParameters.projectId, requestParameters.newLifeCycle, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete bank loan
     * @param {ProjectResourceV2ApiDeleteBankLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBankLoan(
      requestParameters: ProjectResourceV2ApiDeleteBankLoanRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteBankLoan(requestParameters.projectId, requestParameters.bankLoanId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete bonus
     * @param {ProjectResourceV2ApiDeleteBonusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBonus(
      requestParameters: ProjectResourceV2ApiDeleteBonusRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteBonus(requestParameters.projectId, requestParameters.bonusId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete guarantee
     * @param {ProjectResourceV2ApiDeleteGuaranteeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGuarantee(
      requestParameters: ProjectResourceV2ApiDeleteGuaranteeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteGuarantee(requestParameters.projectId, requestParameters.guaranteeId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete investment
     * @param {ProjectResourceV2ApiDeleteInvestmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvestment(
      requestParameters: ProjectResourceV2ApiDeleteInvestmentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteInvestment(requestParameters.projectId, requestParameters.investmentId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Look for projects
     * @param {ProjectResourceV2ApiFindProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findProjects(
      requestParameters: ProjectResourceV2ApiFindProjectsRequest = {},
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<NoubaLightProject>> {
      return localVarFp
        .findProjects(
          requestParameters.searchString,
          requestParameters.searchFields,
          requestParameters.filterOnLoggedAdvisor,
          requestParameters.filterOnCommitteeDate,
          requestParameters.filterOnProjectPhase,
          requestParameters.filterOnProjectActivityArea,
          requestParameters.filterOnFiliere,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Check if lifecycle transition is authorized for project
     * @param {ProjectResourceV2ApiGetBreakingLifecycleTransition1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getBreakingLifecycleTransition1(
      requestParameters: ProjectResourceV2ApiGetBreakingLifecycleTransition1Request,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BreakingTransitionResponse> {
      return localVarFp
        .getBreakingLifecycleTransition1(
          requestParameters.projectId,
          requestParameters.newLifeCycle,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get operations by projectId
     * @param {ProjectResourceV2ApiGetOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOperations(
      requestParameters: ProjectResourceV2ApiGetOperationsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiOperations> {
      return localVarFp
        .getOperations(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get products by projectId and associationId
     * @param {ProjectResourceV2ApiGetProductsByAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductsByAssociation(
      requestParameters: ProjectResourceV2ApiGetProductsByAssociationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ProductsByAssociation>> {
      return localVarFp
        .getProductsByAssociation(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get project by its nouba id and association id
     * @param {ProjectResourceV2ApiGetProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProject(
      requestParameters: ProjectResourceV2ApiGetProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .getProject(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get recently viewed projects by advisor id
     * @param {ProjectResourceV2ApiGetRecentlyViewedProjectsByAdvisorIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecentlyViewedProjectsByAdvisorId(
      requestParameters: ProjectResourceV2ApiGetRecentlyViewedProjectsByAdvisorIdRequest = {},
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<NoubaLightProject>> {
      return localVarFp
        .getRecentlyViewedProjectsByAdvisorId(requestParameters.advisorId, options)
        .then(request => request(axios, basePath))
    },
    /**
     * Used by nouba to import financial plan resources
     * @summary Get financial plan resources import by projectId
     * @param {ProjectResourceV2ApiImportFinancialPlanResources1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    importFinancialPlanResources1(
      requestParameters: ProjectResourceV2ApiImportFinancialPlanResources1Request,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiFinancialPlanResourcesImport> {
      return localVarFp
        .importFinancialPlanResources1(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     * Used by nouba to import operations
     * @summary Get operation import by projectId
     * @param {ProjectResourceV2ApiImportOperations1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    importOperations1(
      requestParameters: ProjectResourceV2ApiImportOperations1Request,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiOperationsImport> {
      return localVarFp
        .importOperations1(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get note url for project
     * @param {ProjectResourceV2ApiRetrieveNoteUrlOnProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    retrieveNoteUrlOnProject(
      requestParameters: ProjectResourceV2ApiRetrieveNoteUrlOnProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .retrieveNoteUrlOnProject(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update bank loan
     * @param {ProjectResourceV2ApiUpdateBankLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBankLoan(
      requestParameters: ProjectResourceV2ApiUpdateBankLoanRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiBankLoan> {
      return localVarFp
        .updateBankLoan(
          requestParameters.projectId,
          requestParameters.bankLoanId,
          requestParameters.updateBankLoanRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update bonus
     * @param {ProjectResourceV2ApiUpdateBonusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBonus(
      requestParameters: ProjectResourceV2ApiUpdateBonusRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiBonusOperation> {
      return localVarFp
        .updateBonus(
          requestParameters.projectId,
          requestParameters.bonusId,
          requestParameters.updateBonusRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update guarantee
     * @param {ProjectResourceV2ApiUpdateGuaranteeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateGuarantee(
      requestParameters: ProjectResourceV2ApiUpdateGuaranteeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiGuaranteeOperation> {
      return localVarFp
        .updateGuarantee(
          requestParameters.projectId,
          requestParameters.guaranteeId,
          requestParameters.updateGuaranteeRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update investment
     * @param {ProjectResourceV2ApiUpdateLoanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLoan(
      requestParameters: ProjectResourceV2ApiUpdateLoanRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiInvestmentOperation> {
      return localVarFp
        .updateLoan(
          requestParameters.projectId,
          requestParameters.loanId,
          requestParameters.updateLoanRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update nouba project
     * @param {ProjectResourceV2ApiUpdateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProject(
      requestParameters: ProjectResourceV2ApiUpdateProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .updateProject(requestParameters.projectId, requestParameters.updateProjectRequest, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for addBankLoan operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiAddBankLoanRequest {
  readonly projectId: number

  readonly addBankLoanRequest: AddBankLoanRequest
}

/**
 * Request parameters for addBonus operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiAddBonusRequest {
  readonly projectId: number

  readonly addBonusRequest: AddBonusRequest
}

/**
 * Request parameters for addGuarantee operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiAddGuaranteeRequest {
  readonly projectId: number

  readonly addGuaranteeRequest: AddGuaranteeRequest
}

/**
 * Request parameters for addLoan operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiAddLoanRequest {
  readonly projectId: number

  readonly addLoanRequest: AddLoanRequest
}

/**
 * Request parameters for changeLifecycle operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiChangeLifecycleRequest {
  readonly projectId: number

  readonly changeLifecycleRequest: ChangeLifecycleRequest
}

/**
 * Request parameters for checkAllTermsOfUse operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiCheckAllTermsOfUseRequest {
  readonly projectId: number
}

/**
 * Request parameters for checkTermsOfUse operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiCheckTermsOfUseRequest {
  readonly projectId: number

  readonly checkTermsOfUseRequest?: CheckTermsOfUseRequest
}

/**
 * Request parameters for createNoteOnProject operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiCreateNoteOnProjectRequest {
  readonly projectId: number

  readonly newLifeCycle?: CreateNoteOnProjectNewLifeCycleEnum
}

/**
 * Request parameters for deleteBankLoan operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiDeleteBankLoanRequest {
  readonly projectId: number

  readonly bankLoanId: string
}

/**
 * Request parameters for deleteBonus operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiDeleteBonusRequest {
  readonly projectId: number

  readonly bonusId: string
}

/**
 * Request parameters for deleteGuarantee operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiDeleteGuaranteeRequest {
  readonly projectId: number

  readonly guaranteeId: string
}

/**
 * Request parameters for deleteInvestment operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiDeleteInvestmentRequest {
  readonly projectId: number

  readonly investmentId: string
}

/**
 * Request parameters for findProjects operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiFindProjectsRequest {
  /**
   * What to look for
   */
  readonly searchString?: string

  /**
   * Fields to filter on. null is equivalent to libelle+structureNom+porteursNomUsage
   */
  readonly searchFields?: Set<FindProjectsSearchFieldsEnum>

  /**
   * Add additional filter on current advisor
   */
  readonly filterOnLoggedAdvisor?: boolean

  /**
   * Add additional filter given committee date
   */
  readonly filterOnCommitteeDate?: string

  /**
   * Project phases to filter on (default is no filter)
   */
  readonly filterOnProjectPhase?: Set<string>

  /**
   * Project activity areas to filter on (default is no filter)
   */
  readonly filterOnProjectActivityArea?: Set<string>

  /**
   * Filière to filter on (default is no filter)
   */
  readonly filterOnFiliere?: Set<string>
}

/**
 * Request parameters for getBreakingLifecycleTransition1 operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiGetBreakingLifecycleTransition1Request {
  readonly projectId: number

  readonly newLifeCycle: GetBreakingLifecycleTransition1NewLifeCycleEnum
}

/**
 * Request parameters for getOperations operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiGetOperationsRequest {
  readonly projectId: number
}

/**
 * Request parameters for getProductsByAssociation operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiGetProductsByAssociationRequest {
  readonly projectId: number
}

/**
 * Request parameters for getProject operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiGetProjectRequest {
  readonly projectId: number
}

/**
 * Request parameters for getRecentlyViewedProjectsByAdvisorId operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiGetRecentlyViewedProjectsByAdvisorIdRequest {
  /**
   * advisor id
   */
  readonly advisorId?: string
}

/**
 * Request parameters for importFinancialPlanResources1 operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiImportFinancialPlanResources1Request {
  readonly projectId: number
}

/**
 * Request parameters for importOperations1 operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiImportOperations1Request {
  readonly projectId: number
}

/**
 * Request parameters for retrieveNoteUrlOnProject operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiRetrieveNoteUrlOnProjectRequest {
  readonly projectId: number
}

/**
 * Request parameters for updateBankLoan operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiUpdateBankLoanRequest {
  readonly projectId: number

  readonly bankLoanId: string

  readonly updateBankLoanRequest: UpdateBankLoanRequest
}

/**
 * Request parameters for updateBonus operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiUpdateBonusRequest {
  readonly projectId: number

  readonly bonusId: string

  readonly updateBonusRequest: UpdateBonusRequest
}

/**
 * Request parameters for updateGuarantee operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiUpdateGuaranteeRequest {
  readonly projectId: number

  readonly guaranteeId: string

  readonly updateGuaranteeRequest: UpdateGuaranteeRequest
}

/**
 * Request parameters for updateLoan operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiUpdateLoanRequest {
  readonly projectId: number

  readonly loanId: string

  readonly updateLoanRequest: UpdateLoanRequest
}

/**
 * Request parameters for updateProject operation in ProjectResourceV2Api.
 */
export interface ProjectResourceV2ApiUpdateProjectRequest {
  readonly projectId: number

  readonly updateProjectRequest: UpdateProjectRequest
}

/**
 * ProjectResourceV2Api - object-oriented interface
 */
export class ProjectResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Add bank loan
   * @param {ProjectResourceV2ApiAddBankLoanRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public addBankLoan(
    requestParameters: ProjectResourceV2ApiAddBankLoanRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .addBankLoan(requestParameters.projectId, requestParameters.addBankLoanRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Add bonus
   * @param {ProjectResourceV2ApiAddBonusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public addBonus(
    requestParameters: ProjectResourceV2ApiAddBonusRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .addBonus(requestParameters.projectId, requestParameters.addBonusRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Add guarantee
   * @param {ProjectResourceV2ApiAddGuaranteeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public addGuarantee(
    requestParameters: ProjectResourceV2ApiAddGuaranteeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .addGuarantee(requestParameters.projectId, requestParameters.addGuaranteeRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Add investment
   * @param {ProjectResourceV2ApiAddLoanRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public addLoan(
    requestParameters: ProjectResourceV2ApiAddLoanRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .addLoan(requestParameters.projectId, requestParameters.addLoanRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Change lifecycle
   * @param {ProjectResourceV2ApiChangeLifecycleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public changeLifecycle(
    requestParameters: ProjectResourceV2ApiChangeLifecycleRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .changeLifecycle(
        requestParameters.projectId,
        requestParameters.changeLifecycleRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get note\'s terms of service
   * @param {ProjectResourceV2ApiCheckAllTermsOfUseRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public checkAllTermsOfUse(
    requestParameters: ProjectResourceV2ApiCheckAllTermsOfUseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .checkAllTermsOfUse(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get note\'s terms of service
   * @param {ProjectResourceV2ApiCheckTermsOfUseRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public checkTermsOfUse(
    requestParameters: ProjectResourceV2ApiCheckTermsOfUseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .checkTermsOfUse(
        requestParameters.projectId,
        requestParameters.checkTermsOfUseRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a note on project
   * @param {ProjectResourceV2ApiCreateNoteOnProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public createNoteOnProject(
    requestParameters: ProjectResourceV2ApiCreateNoteOnProjectRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .createNoteOnProject(requestParameters.projectId, requestParameters.newLifeCycle, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete bank loan
   * @param {ProjectResourceV2ApiDeleteBankLoanRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteBankLoan(
    requestParameters: ProjectResourceV2ApiDeleteBankLoanRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .deleteBankLoan(requestParameters.projectId, requestParameters.bankLoanId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete bonus
   * @param {ProjectResourceV2ApiDeleteBonusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteBonus(
    requestParameters: ProjectResourceV2ApiDeleteBonusRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .deleteBonus(requestParameters.projectId, requestParameters.bonusId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete guarantee
   * @param {ProjectResourceV2ApiDeleteGuaranteeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteGuarantee(
    requestParameters: ProjectResourceV2ApiDeleteGuaranteeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .deleteGuarantee(requestParameters.projectId, requestParameters.guaranteeId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete investment
   * @param {ProjectResourceV2ApiDeleteInvestmentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteInvestment(
    requestParameters: ProjectResourceV2ApiDeleteInvestmentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .deleteInvestment(requestParameters.projectId, requestParameters.investmentId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Look for projects
   * @param {ProjectResourceV2ApiFindProjectsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public findProjects(
    requestParameters: ProjectResourceV2ApiFindProjectsRequest = {},
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .findProjects(
        requestParameters.searchString,
        requestParameters.searchFields,
        requestParameters.filterOnLoggedAdvisor,
        requestParameters.filterOnCommitteeDate,
        requestParameters.filterOnProjectPhase,
        requestParameters.filterOnProjectActivityArea,
        requestParameters.filterOnFiliere,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Check if lifecycle transition is authorized for project
   * @param {ProjectResourceV2ApiGetBreakingLifecycleTransition1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public getBreakingLifecycleTransition1(
    requestParameters: ProjectResourceV2ApiGetBreakingLifecycleTransition1Request,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .getBreakingLifecycleTransition1(
        requestParameters.projectId,
        requestParameters.newLifeCycle,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get operations by projectId
   * @param {ProjectResourceV2ApiGetOperationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getOperations(
    requestParameters: ProjectResourceV2ApiGetOperationsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .getOperations(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get products by projectId and associationId
   * @param {ProjectResourceV2ApiGetProductsByAssociationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getProductsByAssociation(
    requestParameters: ProjectResourceV2ApiGetProductsByAssociationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .getProductsByAssociation(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get project by its nouba id and association id
   * @param {ProjectResourceV2ApiGetProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getProject(
    requestParameters: ProjectResourceV2ApiGetProjectRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .getProject(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get recently viewed projects by advisor id
   * @param {ProjectResourceV2ApiGetRecentlyViewedProjectsByAdvisorIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getRecentlyViewedProjectsByAdvisorId(
    requestParameters: ProjectResourceV2ApiGetRecentlyViewedProjectsByAdvisorIdRequest = {},
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .getRecentlyViewedProjectsByAdvisorId(requestParameters.advisorId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   * Used by nouba to import financial plan resources
   * @summary Get financial plan resources import by projectId
   * @param {ProjectResourceV2ApiImportFinancialPlanResources1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public importFinancialPlanResources1(
    requestParameters: ProjectResourceV2ApiImportFinancialPlanResources1Request,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .importFinancialPlanResources1(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   * Used by nouba to import operations
   * @summary Get operation import by projectId
   * @param {ProjectResourceV2ApiImportOperations1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public importOperations1(
    requestParameters: ProjectResourceV2ApiImportOperations1Request,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .importOperations1(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get note url for project
   * @param {ProjectResourceV2ApiRetrieveNoteUrlOnProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public retrieveNoteUrlOnProject(
    requestParameters: ProjectResourceV2ApiRetrieveNoteUrlOnProjectRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .retrieveNoteUrlOnProject(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update bank loan
   * @param {ProjectResourceV2ApiUpdateBankLoanRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateBankLoan(
    requestParameters: ProjectResourceV2ApiUpdateBankLoanRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .updateBankLoan(
        requestParameters.projectId,
        requestParameters.bankLoanId,
        requestParameters.updateBankLoanRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update bonus
   * @param {ProjectResourceV2ApiUpdateBonusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateBonus(
    requestParameters: ProjectResourceV2ApiUpdateBonusRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .updateBonus(
        requestParameters.projectId,
        requestParameters.bonusId,
        requestParameters.updateBonusRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update guarantee
   * @param {ProjectResourceV2ApiUpdateGuaranteeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateGuarantee(
    requestParameters: ProjectResourceV2ApiUpdateGuaranteeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .updateGuarantee(
        requestParameters.projectId,
        requestParameters.guaranteeId,
        requestParameters.updateGuaranteeRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update investment
   * @param {ProjectResourceV2ApiUpdateLoanRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateLoan(
    requestParameters: ProjectResourceV2ApiUpdateLoanRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .updateLoan(
        requestParameters.projectId,
        requestParameters.loanId,
        requestParameters.updateLoanRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update nouba project
   * @param {ProjectResourceV2ApiUpdateProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateProject(
    requestParameters: ProjectResourceV2ApiUpdateProjectRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectResourceV2ApiFp(this.configuration)
      .updateProject(requestParameters.projectId, requestParameters.updateProjectRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}

export const CreateNoteOnProjectNewLifeCycleEnum = {
  EMERGENCE: "EMERGENCE",
  CREATION: "CREATION",
  REPRISE: "REPRISE",
  DEVELOPMENT: "DEVELOPMENT",
  REBOUND: "REBOUND",
  SCALE: "SCALE"
} as const
export type CreateNoteOnProjectNewLifeCycleEnum =
  (typeof CreateNoteOnProjectNewLifeCycleEnum)[keyof typeof CreateNoteOnProjectNewLifeCycleEnum]
export const FindProjectsSearchFieldsEnum = {
  libelle: "libelle",
  structureNom: "structureNom",
  structureNomCommercial: "structureNomCommercial",
  porteursNomNaissance: "porteursNomNaissance",
  porteursNomUsage: "porteursNomUsage"
} as const
export type FindProjectsSearchFieldsEnum =
  (typeof FindProjectsSearchFieldsEnum)[keyof typeof FindProjectsSearchFieldsEnum]
export const GetBreakingLifecycleTransition1NewLifeCycleEnum = {
  EMERGENCE: "EMERGENCE",
  CREATION: "CREATION",
  REPRISE: "REPRISE",
  DEVELOPMENT: "DEVELOPMENT",
  REBOUND: "REBOUND",
  SCALE: "SCALE"
} as const
export type GetBreakingLifecycleTransition1NewLifeCycleEnum =
  (typeof GetBreakingLifecycleTransition1NewLifeCycleEnum)[keyof typeof GetBreakingLifecycleTransition1NewLifeCycleEnum]
